import { apiUrl } from 'src/util';

type PubSubType = 'publisher' | 'subscriber';
type StreamType = 'camera' | 'screen';

interface StreamContainers {
  publisher: {
    camera: string;
    screen: string;
  };
  subscriber: {
    camera: string;
    screen: string;
  };
}

interface ScreenProperties {
  insertMode: 'append' | 'replace' | 'before' | 'after';
  width: string | number;
  height: string | number;
  showControls: boolean;
  style: {
    buttonDisplayMode: 'auto' | 'off' | 'on';
  };
  videoSource: 'screen' | 'window' | 'application';
  fitMode: 'contain' | 'cover';
}

interface ScreenSharingConfig {
  extensionID: string;
  annotation: boolean;
  externalWindow: boolean;
  dev: boolean;
  screenProperties: ScreenProperties;
}

interface CommunicationConfig {
  callProperties: null | Record<string, unknown>; // Can be extended based on actual OpenTok call properties
}

interface AnnotationConfig {
  absoluteParent: {
    publisher: string;
    subscriber: string;
  };
}

interface ArchivingConfig {
  startURL: string;
  stopURL: string;
}

interface OpenTokOptions {
  streamContainers: (pubSub: PubSubType, type: StreamType) => string;
  controlsContainer: string;
  communication: CommunicationConfig;
  screenSharing: ScreenSharingConfig;
  annotation: AnnotationConfig;
  archiving: ArchivingConfig;
  packages?: string[];
}

export const OT_OPTIONS: OpenTokOptions = {
  // A container can either be a query selector or an HTML Element
  streamContainers(pubSub: PubSubType, type: StreamType): string {
    const containers: StreamContainers = {
      publisher: {
        camera: '#cameraPublisherContainer',
        screen: '#screenPublisherContainer',
      },
      subscriber: {
        camera: '#cameraSubscriberContainer',
        screen: '#screenSubscriberContainer',
      },
    };
    return containers[pubSub][type];
  },
  controlsContainer: '#centerControls',
  communication: {
    callProperties: null, // Using default
  },
  screenSharing: {
    extensionID: 'dnjafhififhecmajapclnkkdjmihpplg',
    annotation: true,
    externalWindow: false,
    dev: true,
    screenProperties: {
      insertMode: 'append',
      width: '100%',
      height: '100%',
      showControls: false,
      style: {
        buttonDisplayMode: 'off',
      },
      videoSource: 'window',
      fitMode: 'contain', // Using default
    },
  },
  annotation: {
    absoluteParent: {
      publisher: '#outerVideoContainer',
      subscriber: '#outerVideoContainer',
    },
  },
  archiving: {
    startURL: `${apiUrl}/video-archive/start`,
    stopURL: `${apiUrl}/video-archive/stop`,
  },
};
